export const faceSwapeStyleOptions = {
    style: {
      shotType: {
        label: '拍摄类型',
        options: {
          portrait: '肖像',
          headPortrait: '头像',
          headAndShoulders: '头肩像',
          halfLength: '半身像',
          fullLength: '全身像',
          face: '脸部',
          closeUp: '特写'
        }
      },
      imagingStyle: {
        label: '成像风格',
        options: {
          standard: '标准模式',
          highContrast: '高对比度模式',
          landscape: '风景模式',
          portrait: '人像模式',
          blackAndWhite: '黑白模式',
          clarityEnhancement: '清晰度增强'
        }
      },
      artisticStyle: {
        label: '艺术风格',
        options: {
          realistic: '写实风格',
          illustration: '插画风格',
          cartoon: '卡通风格',
          watercolor: '水彩风格',
          vintage: '复古风格',
          steampunk: '蒸汽朋克风格'
        }
      },
      artEffect: {
        label: '艺术效果',
        options: {
          oilPainting: '油画效果',
          inkWash: '水墨画效果',
          sketch: '素描效果',
          coloredPencil: '彩色铅笔效果'
        }
      },
      depthOfField: {
        label: '景深',
        options: {
          shallow: '浅景深',
          medium: '中景深',
          deep: '深景深'
        }
      },
      photoEffect: {
        label: '照片效果',
        options: {
          aspectRatioCrop: '长宽比裁剪 (1:1, 16:9)',
          vintage: '复古风格',
          hdr: 'HDR (高动态范围)',
          filmEffect: '胶片效果',
          hardSoftLight: '硬光和柔光',
          longExposure: '长曝光效果'
        }
      },
      specialEffect: {
        label: '特殊效果',
        options: {
          lowSaturation: '低饱和度',
          highContrast: '高对比度',
          hdr: '高动态范围 (HDR)',
          duotone: '双色调效果',
          fluorescent: '荧光/霓虹风格'
        }
      },
      postProcessingStyle: {
        label: '后期处理风格',
        options: {
          filter: '滤镜 (复古、黑白、胶片)',
          sharpening: '锐化',
          denoise: '降噪',
          colorCorrection: '色彩校正',
          filmGrain: '胶片颗粒'
        }
      }
    }
  };
